var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	8613: () => (loadSingletonVersion("default", "rxjs/operators", false, [,[1,7,0,0],[1,6,5,3],1], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 9011))))))),
	2953: () => (loadSingletonVersion("default", "rxjs", false, [,[1,7,0,0],[1,6,5,3],1], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! rxjs */ 1093))))))),
	8819: () => (loadSingletonVersion("default", "@angular/core", false, [4,12,2,17], () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 2435))))))),
	4406: () => (loadSingletonVersion("default", "@angular/router", false, [1,12,0,0], () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(8819), __webpack_require__.e(1121), __webpack_require__.e(4239)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 4239))))))),
	8840: () => (loadSingletonVersion("default", "rxjs/operators", false, [4,6,6,7], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 9011))))))),
	8828: () => (loadSingletonVersion("default", "rxjs", false, [4,6,6,7], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! rxjs */ 1093))))))),
	1169: () => (loadSingleton("default", "@angular/common", false, () => (__webpack_require__.e(3595).then(() => (() => (__webpack_require__(/*! @angular/common */ 3595))))))),
	1121: () => (loadSingletonVersion("default", "@angular/common", false, [4,12,2,17], () => (__webpack_require__.e(3595).then(() => (() => (__webpack_require__(/*! @angular/common */ 3595))))))),
	1984: () => (loadSingletonVersion("default", "@angular/core", false, [1,12,0,0], () => (__webpack_require__.e(2435).then(() => (() => (__webpack_require__(/*! @angular/core */ 2435))))))),
	2621: () => (loadSingletonVersion("default", "@lst/lst-auth", false, [1,2,0,3], () => (__webpack_require__.e(1966).then(() => (() => (__webpack_require__(/*! @lst/lst-auth */ 1966))))))),
	3012: () => (loadSingletonVersion("default", "rxjs", false, [1,6,0,0], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! rxjs */ 1093))))))),
	3218: () => (loadSingletonVersion("default", "@angular/core", false, [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,0,0],1,1,1,1], () => (__webpack_require__.e(2435).then(() => (() => (__webpack_require__(/*! @angular/core */ 2435))))))),
	3821: () => (loadSingletonVersion("default", "@angular/core", false, [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,1,0],1,1,1,1], () => (__webpack_require__.e(2435).then(() => (() => (__webpack_require__(/*! @angular/core */ 2435))))))),
	4108: () => (loadSingletonVersion("default", "rxjs/operators", false, [1,6,0,0], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 9011))))))),
	4898: () => (loadSingletonVersion("default", "@ngx-translate/core", false, [1,13,0,0], () => (__webpack_require__.e(6718).then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 6718))))))),
	7224: () => (loadSingletonVersion("default", "@savvaslearning/lst-ui-core", false, [4,1,1,3], () => (__webpack_require__.e(9399).then(() => (() => (__webpack_require__(/*! @savvaslearning/lst-ui-core */ 9399))))))),
	7698: () => (loadSingletonVersion("default", "@angular/common", false, [1,12,0,0], () => (__webpack_require__.e(3595).then(() => (() => (__webpack_require__(/*! @angular/common */ 3595))))))),
	9866: () => (loadSingletonVersion("default", "@angular/core", false, [1,12,2,0], () => (__webpack_require__.e(2435).then(() => (() => (__webpack_require__(/*! @angular/core */ 2435))))))),
	5121: () => (loadSingletonVersion("default", "@angular/common", false, [4,12,0,0], () => (__webpack_require__.e(3595).then(() => (() => (__webpack_require__(/*! @angular/common */ 3595))))))),
	9135: () => (loadSingletonVersion("default", "@angular/core", false, [4,12,0,0], () => (__webpack_require__.e(2435).then(() => (() => (__webpack_require__(/*! @angular/core */ 2435))))))),
	179: () => (loadSingletonVersion("default", "rxjs/operators", false, [0,6,5,3], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 9011))))))),
	1577: () => (loadSingletonVersion("default", "@angular/core", false, [0,10,0,0], () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 2435))))))),
	3587: () => (loadSingletonVersion("default", "rxjs", false, [0,6,5,3], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! rxjs */ 1093))))))),
	6233: () => (loadSingletonVersion("default", "@angular/common", false, [,[-1,22],[0,12],2], () => (Promise.all([__webpack_require__.e(8819), __webpack_require__.e(3595)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 3595))))))),
	6943: () => (loadSingletonVersion("default", "@angular/core", false, [,[-1,22],[0,12],2], () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 2435)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"926": [
		1169
	],
	"1121": [
		1121
	],
	"1966": [
		5121,
		9135
	],
	"4538": [
		1984,
		2621,
		3012,
		3218,
		3821,
		4108,
		4898,
		7224,
		7698
	],
	"4973": [
		8613,
		2953
	],
	"6718": [
		179,
		1577,
		3587
	],
	"8360": [
		9866
	],
	"8752": [
		4406,
		8840,
		8828
	],
	"8819": [
		8819
	],
	"9399": [
		6233,
		6943
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}